import styled from 'styled-components';
import HrImg from '../../img/hr-maru.png';
import Img1 from '../../img/stemon01.png';
import Img2 from '../../img/stemon02.png';
import Img3 from '../../img/stemon03.png';
import Img4 from '../../img/stemon04.png';
import Img5 from '../../img/stemon05.png';
import Img6 from '../../img/stemon06.png';
import TableLeft from './TableLeft';
import TableRight from './TableRight';
import Table from './Table';

const Main = styled.div`
    margin-top: 50px;
    width: 100%;

`
const Header = styled.h2`
    padding: 15px;
    font-size: 1.5rem;
    background-color: orange;
    color: rgb(255, 255, 255);
    border-radius: 7px;
`
const News = styled.div`
    width: 80%;
    margin: auto;
    margin-bottom: 100px;
`
const StemHada: React.VFC = () => {
    return (
        <Main>
            <p className='text-center text-2xl font-bold'>STEAM教育コース</p>
            <img className='mt-2 mb-5' src={HrImg} width={'100%'} alt='hr' />
            <News><p>物理とプログラミングをバランスよく学ぶ理数IT総合コースです。 プログラミングだけでなく、ものの仕組みを低学年のうちからしっかり学ぶことで、 高学年になった時の問題解決の幅が広がります。</p></News>

            {/* ******************************************************************************************************************************************************************* */}
            <Header>キンダリークラス(年中・年長)</Header>
            <TableLeft
                text1={'STEAM領域に親しみを持ち、自然と好奇心が育まれるクラスです。'}
                text2={'「飛行機はどうして飛ぶの？」「浮く・沈むってなに？」など身の回りにある「ものの仕組み」や言葉の概念に触れていきます。'}
                text3={'ブロックを使ったアクティビティを通して楽しく、知識・興味の幅を広げます。'}
                text4={'タブレットやロボット、カードゲームを用いながら、プログラミング的思考の基礎を楽しみながら学びます。'}
                src={Img1}
            />
            <Table
                td1={'開講曜日'} td2={'火曜日（水曜日新規開講予定）　※年間24回（月2回）'}
                td3={'時間'} td4={'火曜日　15:30～16:20'}
                td5={''} td6={'水曜日　15:10～16:00（新規開校予定）'}
                td7={'月謝'} td8={'9,460円（税込）'}
            />

            {/* ******************************************************************************************************************************************************************* */}
            <Header>ベーシッククラス(小１～小3)</Header>
            <TableRight
                text1={'STEAMの基礎を学ぶクラスです。'}
                text2={'ブロック制作などを通して、自転車やエレベーターなどを作用させるギヤや車輪といった身近な「しかけ」「ものの仕組み」を学びます。'}
                text3={'プログラミングが日常生活の多くの場面で利用されていることを理解し、アプリを使用してプログラミングの基礎を学習します。'}
                src={Img2}
            />
            <Table
                td1={'開講曜日'} td2={'火曜日・金曜日　※年間40回（月3，4回）'}
                td3={'時間'} td4={'金曜日　17:45～18:45（新規開校予定）'}
                td5={''} td6={'※現在定員いっぱいの為、新規開校予定の金曜日のみ募集'}
                td7={'月謝'} td8={'12,430円（税込）'}
            />

            {/* ******************************************************************************************************************************************************************* */}
            <Header>アドバンスクラス(小2～小4)</Header>
            <TableLeft
                text1={'STEAMの応用を学ぶクラスです。'}
                text2={'ベーシッククラスを学んだ「ものの仕組み」についてより発展的な内容を学びながら、想像力、論理的思考力を育みます。'}
                text3={'プログラミングではゲームやメディアアートの作成を通じて、複数のプログラミングを学びます。'}
                src={Img3}
            />
            <Table
                td1={'開講曜日'} td2={'水曜日・土曜日　※年間40回（月3，4回）'}
                td3={'時間'} td4={'水曜日　16:15～17:15'}
                td5={''} td6={'土曜日　11:30～12:30'}
                td7={'月謝'} td8={'12,430円（税込）'}
            />

            {/* ******************************************************************************************************************************************************************* */}

            {/* ******************************************************************************************************************************************************************* */}
            <Header>キッズエリートクラス（小３～４)</Header>
            <TableRight
                text1={'STEAMの知識を活用して課題認識力/問題解決力を育むクラスです。'}
                text2={'ブロックに加えて様々な工作材料を用いた制作を行うことで興味の幅を広げます。'}
                text3={'プログラミング＆ロボティクスコースへ進む準備段階として、PCやタブレットを使用した制作を行い、コンピューターサイエンスの基礎を学びます。'}
                src={Img4}
            />
            <Table
                td1={'開講曜日'} td2={'火曜日・水曜日・土曜日　※年間40回（月3，4回）'}
                td3={'時間'} td4={'現在定員いっぱいの為募集なし'}
                td5={'月謝'} td6={'13,530円（税込）'}
            />

            {/* ******************************************************************************************************************************************************************* */}

            {/* ******************************************************************************************************************************************************************* */}
            <Header>プログラミング＆ロボティクス 1st(小４～小６)</Header>
            <TableRight
                text1={'物理の原理とパソコンを使ったプログラミングで、ゲーム制作やロボットの制御を行い、プログラミングのスキルを楽しみながら学ぶクラスです。'}
                text2={'コンピューターを活用した問題解決力や課題発見力を高めます。'}
                text3={'プログラミングの基本を活かし楽しくゲームの制作を行うゲームクリエイター編と、基礎的なプログラムによってロボットを制御するロボットクリエイター編の２つからなります。'}
                text4={'教材ではScratchやロボットプログラミングを行います。'}
                src={Img5}
            />
            <Table
                td1={'開講曜日'} td2={'火曜日・水曜日・土曜日　※年間40回（月3，4回）'}
                td3={'時間'} td4={'火曜日　17:50～18:50'}
                td5={''} td6={'土曜日　11:15～12:15'}
                td7={''} td8={'※水曜日定員いっぱいの為募集なし'}
                td9={'月謝'} td10={'16,830円（税込）'}
            />

            {/* ******************************************************************************************************************************************************************* */}

            <Header>プログラミング＆ロボティクス 2nd(1st修了者)</Header>
            <TableLeft
                text1={'「プロロボ1st」に引き続き、コンピューターを活用した問題発見や課題解決を行います 。'}
                text2={'これまでに身につけたプログラミングスキルを複合的に用いてゲーム制作を行い、自分の「つくりたい」を表現します 。'}
                text3={' 複数のモーターやセンサーを使ったより実践的なプログラムによってロボットを制御し、課題を解決していきます 。'}
                src={Img6}
            />
            <Table
                td1={'開講曜日'} td2={'金曜日　※年間40回（月3，4回）'}
                td3={'時間'} td4={'現在定員いっぱいの為募集なし'}
                td5={'月謝'} td6={'16,830円（税込）'}
            />

            {/* ******************************************************************************************************************************************************************* */}


        </Main>

    );
}
export default StemHada;